module.exports = __webpack_public_path__ + "static/media/18ECA14.ab5ad6c5.jpg";